import { onMounted, onUnmounted, ref } from 'vue';

type UseScriptOptions = {
  manual: boolean;
};

export default function useScriptTag(url: string, options: UseScriptOptions = { manual: false }) {
  const scriptTag = ref<HTMLScriptElement | null>(null);
  const isLoaded = ref(false);
  const error = ref<Error | null>(null);

  const setIsLoaded = () => (isLoaded.value = true);
  const setError = (e: ErrorEvent) => (error.value = e.error);

  function loadScript() {
    let el = document.querySelector<HTMLScriptElement>(`script[src="${url}"]`);

    if (!el) {
      isLoaded.value = false;
      error.value = null;

      el = document.createElement('script');

      el.type = 'text/javascript';
      el.async = true;
      el.src = url;
      el.addEventListener('load', setIsLoaded);
      el.addEventListener('error', setError);
      document.head.appendChild(el);
    } else {
      isLoaded.value = true;
    }

    scriptTag.value = el;
  }

  function unloadScript() {
    if (!document) {
      return;
    }

    const elToBeRemoved = document.querySelector<HTMLScriptElement>(`script[src="${url}"]`);

    if (elToBeRemoved) {
      elToBeRemoved.removeEventListener('load', setIsLoaded);
      elToBeRemoved.removeEventListener('error', setError);

      document.head.removeChild(elToBeRemoved);

      scriptTag.value = null;
      isLoaded.value = false;
    }
  }

  if (!options.manual) {
    onMounted(loadScript);
    onUnmounted(unloadScript);
  }

  return { scriptTag, load: loadScript, unload: unloadScript, isLoaded, error };
}
